export const STATISTICS_EN = {
  Usage: 'Usage',
  statistics: 'Statistics',
  AllTheThingsYouHaveGenerated: 'All the things you have generated',
  MonthlyGeneration: 'Monthly Generation',
  WeeklyActivity: 'Weekly Activity',
  MostUsedModels: 'Most Used Models',
  FavoritePrompts: 'Favorite Prompts',
  NothingGeneratedYet: 'Nothing generated yet'
}

export const STATISTICS_DE = {
  Usage: 'Nutzung',
  statistics: 'Statistiken',
  AllTheThingsYouHaveGenerated: 'Alle Dinge, die Sie generiert haben',
  MonthlyGeneration: 'Monatliche Generierung',
  WeeklyActivity: 'Wöchentliche Aktivität',
  MostUsedModels: 'Meistgenutzte Modelle',
  FavoritePrompts: 'Lieblings-Prompts',
  NothingGeneratedYet: 'Noch nichts generiert'
}
